import { render } from "./MainCSS.vue?vue&type=template&id=08705d20"
import script from "./MainCSS.vue?vue&type=script&lang=js"
export * from "./MainCSS.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__